// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface JobProcessRead
 */
export interface JobProcessRead {
  /**
   *
   */
  id: string;
  /**
   *
   */
  name: string;
}

/**
 * Check if a given object implements the JobProcessRead interface.
 */
export function instanceOfJobProcessRead(value: object): value is JobProcessRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function JobProcessReadFromJSON(json: any): JobProcessRead {
  return JobProcessReadFromJSONTyped(json, false);
}

export function JobProcessReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): JobProcessRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function JobProcessReadToJSON(json: any): JobProcessRead {
  return JobProcessReadToJSONTyped(json, false);
}

export function JobProcessReadToJSONTyped(
  value?: JobProcessRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
  };
}
